import { Fragment, useState, useCallback, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form, Alert, Stack, ProgressBar, Modal, FormCheck } from "react-bootstrap";
import useAxios from "axios-hooks";
import DatePicker from "react-datepicker";
import BrandContext from "./BrandContext";
import { LinkContainer } from "react-router-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

export default function Channel(props) {
    const theme = useContext(BrandContext);
    const nav = useNavigate();
    const params = useParams();
    const [prPostDate, setPostDate] = useState(new Date());
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const handleAcceptedTerms = (e) => {
        setAcceptedTerms(e.target.checked)
    };
    const [showConfirmFree, setShowConfirmFree] = useState(false);
    const [confirmFree, setConfirmFree] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showPaidModal, setShowPaidModal] = useState(false);
    const handleClosePaidModal = () => setShowPaidModal(false);
    const handleShowPaidModal = () => setShowPaidModal(true);
    const [{ data: currentPR, loading: loadingPR, error: prError }, refetchPR] = useAxios({
        method: 'get',
        url: '/pr/get',
        params: {
            id: params.prId
        },
    });
    useEffect(() => {
        // Content wasn't completed, go back to content
        if (currentPR && !currentPR?.prTitle) {
            nav('../content');
            return;
        }
        const status = currentPR?.status;
        switch (status) {
            case 'paid':
                nav('../checkout');
                return;
            case 'submitted':
                nav('../submitted');
                return;
            default:
                break;
        }
    }, [currentPR]);


    const [
        { data: draft, loading: working, error: createError },
        executePutChannel
    ] = useAxios(
        {
            url: '/pr/channel',
            method: 'POST'
        },
        { manual: true }
    )

    function promote() {
        executePutChannel({
            data: {
                id: params.prId,
                prPostDate: prPostDate || new Date().toISOString(),
                acceptedTerms,
                prTitle: currentPR?.prTitle,
            }
        })
            .then((r) => {
                nav('../promote')
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }



    const [
        { data: submitResult, loading: submitting, error: errorSubmitting },
        executePutSubmit
    ] = useAxios(
        {
            url: '/pr/submit',
            method: 'POST'
        },
        { manual: true }
    )

    function submitPR() {
        executePutSubmit({
            data: {
                id: currentPR.id,
                additionalBrands: Object.keys(theme?.relatedBrands || {}) || []
            }
        })
            .then((r) => {
                nav('../submitted')
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }


    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <Row className="justify-content-center">
                    <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                        <p style={{ fontSize: "14px" }}><span className="sr-light">Create</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="fw-bold">Promote</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Submit</span></p>
                        <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>What if you could guarantee your press release gets audience visibility, now?</p>
                        <p>Some stories just aren't newsworthy to editors. Sometimes, submissions get lost in the shuffle. <span className="fw-bold">But your news needs to get out now.</span> If you want a guarantee that your news goes live on our platform, add an immediate posting to our Press Release Channel.</p>
                    </Col>
                    <Col sm={{ span: 'auto', order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ padding: "15px", display: "grid", alignContent: "start", justifyContent: "start" }}>
                        <Image style={{ height: "50px" }} fluid src={theme?.marketing?.logo}></Image>
                    </Col>
                </Row>
                <Row className="justify-content-center" >
                    <Col md="4">
                        <div style={{ padding: "24px" }} className="bg-swiftrev" >
                            <h5 className="fw-bold">What's Included</h5>
                            <ul style={{ paddingLeft: "16px" }}>
                                <li>Visibility in our Press Release Channel</li>
                                <li>Post immediately, or at an embargoed time</li>
                                <li>Editorial coverage consideration</li>
                            </ul>
                            <div style={{ fontSize: "50px", fontWeight: "bolder" }}>{theme?.priceSymbol}{theme?.price} {theme?.priceAbbr}</div>
                        </div>
                    </Col>
                    <Col md="4">
                        <div style={{ padding: "24px" }}>
                            <h5 className="fw-bold">About Our Audience</h5>
                            <p>Monthly Audience Reach: {theme?.marketing?.audience?.toLocaleString()}</p>
                            <div>Top Job Functions</div>
                            <ul style={{ paddingLeft: "16px" }}>
                                {theme?.marketing?.jobs?.map((job, indx) => {
                                    return <li key={'indx-' + indx}>{job}</li>
                                })}
                            </ul>
                        </div>
                    </Col>
                    <Col md="4">
                        <div style={{ padding: "24px" }}>
                            <h5 className="fw-bold">Is it Newsworthy?</h5>
                            <p>The following types of news often do not get editorial coverage and are ideal for our Press Release Channel:</p>
                            <ul style={{ paddingLeft: "16px" }}>
                                <li>Investment Success / Fundraising</li>
                                <li>Award Recognition</li>
                                <li>Financial Results</li>
                                <li>Event or Initiative Announcement</li>
                            </ul>
                        </div>
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col xs="12">
                        <Alert variant="danger"><div className="text-center">Did you know that, on average, <span className="fw-bold">only 1 in 7</span> editor-reviewed press releases get coverage?</div></Alert>
                    </Col>
                </Row>
                <div>
                    <Button onClick={() => handleShowPaidModal()} size="lg" variant="swiftrev">Add a Paid Posting</Button>
                </div>
                <br />
                <div>
                    <Button onClick={() => setShowConfirmFree(true)} variant="link" style={{ textDecorationLine: "none", padding: "0" }}>No thanks - I prefer to only notify editors of my press release and defer guaranteed visibility on the platform</Button>
                </div>
                <br />
            </Container>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{theme?.accountName} Content Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body><div dangerouslySetInnerHTML={{ "__html": theme?.accountContentPolicy }}></div></Modal.Body>
            </Modal>
            <Modal show={showConfirmFree} onHide={() => { setShowConfirmFree(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title><strong>Are you sure you don't want to purchase a spot in our press release channel?</strong></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul style={{ paddingLeft: "1rem" }}>
                        <li>Get immediate visibility with your target audience</li>
                        <li>Get priority presentation to the editors for additional editorial coverage</li>
                        <li>Avoid finding out too late that your news won't be covered</li>
                    </ul>
                    <br />
                    <Button onClick={() => setShowConfirmFree(false)} size="lg" variant="swiftrev">Return to the paid press release</Button>
                    <br /><br />
                    <div className="sr-alert-light">
                        <Form.Check defaultChecked={confirmFree} onChange={event => setConfirmFree(event.target.checked)} label="I'm sure"></Form.Check>
                        <div>I prefer to only submit to editorial staff. I understand that the editorial staff has no obligation to confirm if my press release will be accepted. If declined, I will have the opportunity to quickly purchase a spot in the Press Release Channel.</div>
                        <br />
                        <Button hidden={!confirmFree} onClick={() => submitPR()} variant="swiftrev">Submit</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showPaidModal} onHide={handleClosePaidModal} size="lg" centered>
                <Modal.Body>
                    <Row className="justify-content-center" style={{ padding: "20px" }}>
                        <Col md="6">
                            <h3 className="fw-bold">The Details</h3>
                            <br></br>
                            <h5>Post Date</h5>
                            <div>
                                <DatePicker
                                    selected={prPostDate}
                                    onChange={(date) => setPostDate(date)}
                                    showTimeSelect
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                />
                            </div>
                            <br />
                            <Form.Check
                                type="checkbox"
                                onChange={handleAcceptedTerms}
                                label={<Button onClick={handleShow} style={{ padding: 0 }} variant="link">Accept {theme?.accountName} Content Policy</Button>}
                            />
                            <br />
                            <Stack direction="horizontal" gap={3}>
                                <Button onClick={() => promote()} disabled={working || !acceptedTerms} size="lg" variant="swiftrev">Next</Button>
                            </Stack>
                        </Col>
                        <Col md="6">
                            <div style={{ padding: "24px" }} className="bg-swiftrev" >
                                <h5 className="fw-bold">What's Included</h5>
                                <ul style={{ paddingLeft: "16px" }}>
                                    <li>Visibility in our Press Release Channel</li>
                                    <li>Post immediately, or at an embargoed time</li>
                                    <li>Editorial coverage consideration</li>
                                </ul>
                                <div style={{ fontSize: "50px", fontWeight: "bolder" }}>{theme?.priceSymbol}{theme?.price} {theme?.priceAbbr}</div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
}